import React , { Component} from 'react';
import { MsalContext } from "../Auth/msal-context";
import {Row, Col} from 'react-bootstrap';
import lottie from 'lottie-web';
import animationData from '../images/lf20_v7nRH3.json';

import './Login.scss';
export default class LoadingProfilePreferences extends Component {
    static contextType = MsalContext;
    constructor(props){
        super(props);


        this.state = {
            wording: this.props.wording || 'Setting your profile and preferences...'
        };

    }

    componentDidMount(){
        lottie.loadAnimation({
            container: this.animBox, // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: animationData // the path to the animation json
        });
    }

    render(){
        return (
            <div id="Login">
                <Row className="login-container">
                   <Col lg={{span : 6, offset : 3}} className="login-wrapper">
                       <div style={{width: "320px", margin: '0 auto'}} ref={ ref => this.animBox = ref}></div>
                       <p className="login-title">Fetch</p>
                       <p className="login-sub">{this.state.wording}</p>
                   </Col>
                </Row>
            </div>
        );
    }
}